import { render, staticRenderFns } from "./SvgManipulation.vue?vue&type=template&id=637c184a&"
import script from "./SvgManipulation.vue?vue&type=script&lang=ts&"
export * from "./SvgManipulation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports